import useQueryContext from "./useQueryContext";

/**
 * Will return the queryId for the current context, if this is a saved search. Otherwise will return null.
 */
export default function useGetContextQueryId() {
    const context = useQueryContext();

    return context?.savedSearchId ?? null;
}